module.exports = __webpack_public_path__ + "static/media/left-bg-bs.4fac85ed.png";